import { oz } from '@weft/utils';
import { ApiDateSchema } from '../../../primitives';

export const UNCHARGED_USAGE_REASON = Object.freeze({
  NO_ACTIVE_CONTRACT: 'No active contract',
  NO_CONTRACT: 'No contract',
  NO_METER: 'No meter',
});

export type UnchargedUsageReason = typeof UNCHARGED_USAGE_REASON[keyof typeof UNCHARGED_USAGE_REASON];

export const UnchargedUsageReportSchema = oz.array(oz.object({
  measurementId: oz.string(),
  customerId: oz.string(),
  meterId: oz.string(),
  contractId: oz.string().optional(),
  meterName: oz.string(),
  customerName: oz.string(),
  period: oz.object({
    startTime: ApiDateSchema,
    endTime: ApiDateSchema,
  }),
  value: oz.number(),
  reason: oz.nativeEnum(UNCHARGED_USAGE_REASON),
})).openapi('UnchargedUsageReportResponseSchema');

export type UnchargedUsageReport = oz.TypeOf<typeof UnchargedUsageReportSchema>;